import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/NewRequest';

export interface IPhones {
  phoneType: number;
  phoneTypeDesc: string;
  prefixId: number;
  prefix: number;
  phoneNum: string;
  email: string;
}

export interface IFamilyMembers {
  relation: number;
  relationDesc: string;
  idNumber: string;
  firstName: string;
  lastName: string;
  birthDate: Date;
  gender: number;
}

export interface IAddresses {
  addressTypeId: number;
  addressTypeDesc: string;
  street: string;
  numHouse: string;
  numApartment: string;
  entrance: string;
  neighborhood: string;
  townId: number;
  zipCode: string;
  postOffice: string;
  countryId: number;
  abroadTown: string;
}

export interface IDisabilitySections {
  caseNumber: string;
  lastCommitteeDate: Date;
  sectionCode: string;
  sectionDescription: string;
  disabilityStartDate: Date;
  currentDisabilityStartDate: Date;
  disabilityPercent: string;
  sectionValidTo: string;
  considerPercent: string;
  nonConsiderPercent: string;
}

export interface IPersonalDetails {
  mainPhonePrefix?: number;
  mainPhone?: string;
  caseNumber: string;
  israeliId: string;
  firstName: string;
  lastName: string;
  familyStatus: string;
  maritalStatusId: number;
  accountNum: string;
  phones: IPhones[];
  familyMembers: IFamilyMembers[];
  addresses: IAddresses[];
  disabilityPercent: string;
  disabilitySections: IDisabilitySections[];
  disabilityStatus: string | undefined;
  bankDetails: {
    accountNum: string;
    bankCode: string;
    bankName: string;
    branchCode: string;
    branchName: string;
  };
}

export const getPersonalDetails = async () => {
  const personalDetails = await api.get<IPersonalDetails>(
    addImposterToUrl(`${baseURL}/PersonalDetails`, true)
  );
  const sensitizedPersonalDetails = personalDetails.data;
  if (!sensitizedPersonalDetails) return;

  if (!sensitizedPersonalDetails) return;

  if (sensitizedPersonalDetails.mainPhone) {
    sensitizedPersonalDetails.mainPhone =
      personalDetails.data.mainPhone?.trim();
    if (sensitizedPersonalDetails.mainPhone?.length !== 7)
      sensitizedPersonalDetails.mainPhone = '';
  }

  if (sensitizedPersonalDetails.phones?.length > 0)
    sensitizedPersonalDetails.phones = personalDetails.data.phones.map(
      (phone) => ({
        ...phone,
        phoneNum:
          phone.phoneNum.trim().length !== 7 ? '' : phone?.phoneNum.trim(),
      })
    );

  if (sensitizedPersonalDetails) return sensitizedPersonalDetails;
};
